var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: fit-content;\n  margin: 0 auto;\n  padding-bottom: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  \n  div:focus-visible {\n    outline: none !important;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: fit-content;\n  margin: 0 auto;\n  padding-bottom: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  \n  div:focus-visible {\n    outline: none !important;\n  }\n"])), function (_a) {
    var withoutDots = _a.withoutDots;
    return withoutDots ? 0 : 32;
}, function (_a) {
    var withoutArrows = _a.withoutArrows;
    return withoutArrows ? 0 : 32;
}, function (_a) {
    var withoutArrows = _a.withoutArrows;
    return withoutArrows ? 0 : 32;
});
var templateObject_1;
